import * as React from 'react';
export const GridApiContext = /*#__PURE__*/React.createContext(undefined);

if (process.env.NODE_ENV !== 'production') {
  GridApiContext.displayName = 'GridApiContext';
}


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/components/GridApiContext.js
// module id = 623
// module chunks = 25